import { render, staticRenderFns } from "./SubmitScreening.vue?vue&type=template&id=11847b1d&"
import script from "./SubmitScreening.vue?vue&type=script&lang=js&"
export * from "./SubmitScreening.vue?vue&type=script&lang=js&"
import style0 from "./SubmitScreening.vue?vue&type=style&index=0&id=11847b1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports